import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

// Floating "scroll for more" arrow shown on every page until the visitor scrolls.
export default function ScrollHint() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 700);
    const onScroll = () => {
      if (window.scrollY > 80) {
        setVisible(false);
        window.removeEventListener("scroll", onScroll);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      clearTimeout(showTimer);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const handleClick = () => {
    window.scrollBy({ top: window.innerHeight * 0.85, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Scroll down for more"
      data-testid="scroll-hint"
      className={`fixed right-5 md:right-7 bottom-28 md:bottom-32 z-40 transition-all duration-500 group ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2 pointer-events-none"
      }`}
    >
      <span className="flex items-center gap-2 bg-white/95 backdrop-blur-md border border-[#0E2A57]/20 shadow-[0_8px_24px_rgba(14,42,87,0.08)] pl-3 pr-2 py-1.5 hover:bg-[#0E2A57] hover:text-white hover:border-[#0E2A57] text-[#0E2A57] transition-colors">
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] font-medium hidden sm:inline">
          Scroll
        </span>
        <span className="w-7 h-7 flex items-center justify-center animate-bounce">
          <ChevronDown size={16} />
        </span>
      </span>
    </button>
  );
}
